import apiClient from './apiClient';

const BASE = '/api/v1.0/rbac';

// Permission catalog + the caller's own effective permissions.
export const getPermissionCatalog = () => apiClient.get(`${BASE}/permissions`);
export const getMyPermissions = () => apiClient.get(`${BASE}/me/permissions`);

// Roles CRUD.
export const listRoles = () => apiClient.get(`${BASE}/roles`);

/**
 * Role picker: id/name/description only, for features that let a user CHOOSE a
 * role without being a role administrator (e.g. sharing a dashboard with
 * specific roles). `listRoles` above returns full permission sets and is gated
 * on roles.manage/users.manage, so it 403s for a dashboard editor.
 */
export const listSelectableRoles = (config) =>
  apiClient.get(`${BASE}/roles/selectable`, config);
export const createRole = (payload) => apiClient.post(`${BASE}/roles`, payload);
export const updateRole = (id, payload) => apiClient.put(`${BASE}/roles/${id}`, payload);
export const deleteRole = (id) => apiClient.delete(`${BASE}/roles/${id}`);

// Per-user role assignment.
export const getUserRoles = (userId) => apiClient.get(`${BASE}/users/${userId}/roles`);
export const setUserRoles = (userId, roleIds) => apiClient.put(`${BASE}/users/${userId}/roles`, { roleIds });
